import React from 'react';
import { Link } from 'gatsby';
import Helmet from 'react-helmet';

import Layout from '../components/Layout';
import Container from '../components/Container';

import Seo from '../components/SEO';
import { Typography, Button, Grid } from '@material-ui/core';

import CloudImage from '../assets/images/services/img_cloud_apps.png';
import ContactImage from '../assets/images/services/img_contact_us.png';
import ProcessImage from '../assets/images/services/img_process.png';
import PeopleImage from '../assets/images/services/img_right_people.png';
import OutsourcingImage from '../assets/images/services/img_software_outsourcing.png';

const cardData = [
    {
        title: 'Software outsourcing And digital solutions',
        description: 'With over 8 years of dedicated Cloud SaaS, PaaS and video conferencing app. development experience, we have the skills and process to be a reliable, and efficient digital developer.',
        image: OutsourcingImage,
        bgColor: '#F7F7F7',
    },
    {
        title: 'Guarantee and security zeal for your cloud apps.',
        description: 'We place security and performance first. It’s our job to create a system that is robust and work’s to spec., ensuring there is redundancy, security and efficiency that fits your needs.',
        image: CloudImage,
        leftImage: true,
    },
    {
        title: 'A process that works.',
        description: 'We make sure each projects kicks off and finishes to plan. We use revolutionary industry best practices and develop systems that you and your customer wants by visualizing process and ensuring each click falls exactly where you imagined it.',
        image: ProcessImage,
        bgColor: '#F7F7F7',
    },
    {
        title: 'We have the right people and the tools',
        description: 'We have the best talent, and they have the right tools for their jobs. Our process are compliant with the best of the best, let’s talk and get to know each other. Because we are here for you no matter the complexity, or the simplicity.',
        image: PeopleImage,
        leftImage: true,
    },
    {
        title: 'Based in Australia & Sri Lanka',
        description: 'The best people in IT are from Australia and Sri Lanka, they say :) Having co-locations that cover the global time zones helps customers from US, Europe, Aussi etc. have smooth back office communications with us.',
        image: ContactImage,
        bgColor: '#F7F7F7',
    }
]

const SideBySide = ({title, description, image, leftImage, bgColor}) => {
    return (
        <div className="card-wrapper" style={{ background: bgColor || '#fff' }}>
            <Container>
                <Grid container className="grid-wrapper">
                    <Grid item xs={12} md={5} className="left-grid" style={{ order: leftImage ? 3 : 1 }}>
                        <h3 className="card-heading">{title}</h3>
                        <div className="description small-font">{description}</div>
                    </Grid>
                    <Grid item xs={12} md={5}  className="right-grid">
                        <img src={image} alt={title} />
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

const ServicesPage = () => {
    const Description =
        'Meetrix provides multi-platform, open-source video conferencing solutions based on Jitsi, Janus, Big Blue Button, Kurento, Freeswitch, Twilio, and many others. Our focus on Jitsi has been recognized by hundreds of global sector leaders from a multitude of segments, such as military, government, NGO, telecom, software, and healthcare. They seek our professional services in upgrading, load testing, customization, infrastructure setup and automation, modifications, and integrations of Jitsi.';
    return (
        <Layout pageName="Services">
            <Seo title="Meetrix.IO | Services" description={Description} />
            <Helmet>
      {/* Global site tag (gtag.js) - Google Analytics */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=UA-118777783-1"></script>
      <script type="text/javascript">
        {`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'UA-118777783-1');`}
      </script>
      {/* <!-- Google Tag Manager --> */}
      <script type="text/javascript">{`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-N8NWRND');
      `}</script>
      {/* <!-- End Google Tag Manager --> */}
      {/* <!-- Google tag (gtag.js) --> */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-20D2B15V4Y"></script>
      <script>
        {`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'G-20D2B15V4Y');`}
      </script>
      </Helmet>
      {/* <!-- Google Tag Manager (noscript) --> */}
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N8NWRND"
      height="0" width="0" style={{display:'none', visibility:'hidden' }}></iframe></noscript>
      {/* <!-- End Google Tag Manager (noscript) --> */}
            
            <div className="services-wrapper" id="services-page">
            <div className="intro">
                <Container>
                <Typography className="intro-title" variant='h3' component="h1">Let’s Build your Digital products</Typography>
                  <Link className="yellow-button" to="/contact-us">
                  Book a consultant - it’s free
          </Link>
                </Container>
            </div>
                {cardData.map((data) => {
                    return (
                        <SideBySide 
                            title={data.title}
                            description={data.description}
                            image={data.image}
                            bgColor={data?.bgColor}
                            leftImage={data?.leftImage}
                        />
                    )
                })}
            </div>
        </Layout>
    );
};

export default ServicesPage;
